// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../styles/colors.module.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "/* wrapper around an input, label, and error status */\n._1NM-kKmnH_6zdBi-PzQfsJ {\n  margin-bottom: 20px;\n}\n\n.fdV_Rc_vk-Z1A3cb_WQn5 {\n  font-size: 14px;\n  line-height: 18px;\n  color: #32445A;\n  font-weight: 600;\n}\n\n.fdV_Rc_vk-Z1A3cb_WQn5._1ZXapWmh240u3v_aoKuWXe, ._2gfMrDQbKlM7eEH-Rj8QNE {\n  margin-left: 8px;\n  color: " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-error"] + ";\n  font-weight: 400;\n}", ""]);
// Exports
exports.locals = {
	"colors": "\"../../../styles/colors.module.css\"",
	"hc-outline": "" + ___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-outline"] + "",
	"hc-error": "" + ___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-error"] + "",
	"inputGroup": "_1NM-kKmnH_6zdBi-PzQfsJ",
	"label": "fdV_Rc_vk-Z1A3cb_WQn5",
	"error": "_1ZXapWmh240u3v_aoKuWXe",
	"labelError": "_2gfMrDQbKlM7eEH-Rj8QNE"
};
module.exports = exports;
